import React, { FC } from 'react';
import { DataTable } from '@sdir/sds';
import { useDataSorting } from '@sdir/utilities/lib/hooks';
import styled from 'styled-components';
import { TableDefinition } from '../../../helpers/TableHeaders';

interface SortableDataCardProps {
  table: TableDefinition;
  className?: string;
  autoWidth?: boolean;
}

export const SortableDataTable: FC<SortableDataCardProps> = ({
  table,
  className,
  autoWidth = false,
}) => {
  const { sortedData, setSortedBy } = useDataSorting(table.data, table.columns);

  return (
    <StyledDataTable
      className={className}
      columns={table.columns}
      data={sortedData}
      onHeaderClick={setSortedBy}
      collapsable={table.collapsable}
      collapsableText={table.collapsableText}
      sortableKeys={table.sortableKeys}
      autoWidth={autoWidth}
    />
  );
};

const StyledDataTable = styled(DataTable)<{ autoWidth }>`
  &&& {
    th {
      padding-top: 1rem;
      padding-bottom: 1rem;
      width: auto;
      ${({ autoWidth }) => autoWidth && 'width: auto'};
    }

    td {
      padding-top: 2rem;
      padding-bottom: 2rem;
      ${({ autoWidth }) => autoWidth && 'width: auto'};
    }
  }
`;
